
<div
        [style]="{'background-color': propertyValue}"
        class="rounded-full bg-transparent size-5"
></div>